import React, { useContext, useState } from 'react';
import { ApplicationUIContext } from '@yuhuinc/ui-library';
import { useQuery } from '@tanstack/react-query';

import { Card, Spin } from 'antd';

import SideBarIncentives from './SideBarIncentives';

import SideBarStepper from './SideBarStepper';
import SidebarPaymentDetails from './SideBarPaymentDetails';
import SidebarAppDetails from './SideBarAppDetails';
import SideBarProgress from './SideBarProgress';
import { getCotenant } from '../api/cotenants';
import { DUMMY_COTENANT } from 'constants/tenantApplication.constants';

const ApplicationSidebar = ({ cotenantId, applicationWizard, isPreview }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [showSummary, setShowSummary] = useState(!isMobile);

  let cotenantQuery = {
    queryKey: ['cotenant', cotenantId],
    retry: false,
    staleTime: 120000,
    queryFn: () =>
      getCotenant(cotenantId).then((res) => {
        return res.cotenant;
      }),
  };

  if (isPreview) {
    cotenantQuery['staleTime'] = 'Infinity';
    cotenantQuery['initialData'] = DUMMY_COTENANT;
  }

  const { data: cotenant, isLoading } = useQuery(cotenantQuery);

  if (isLoading) {
    return (
      <Card>
        <Spin />
      </Card>
    );
  }

  const lease = cotenant?.lease;

  return (
    <Card>
      <div onClick={() => isMobile && setShowSummary(!showSummary)}>
        {applicationWizard ? (
          <SideBarProgress />
        ) : (
          <SideBarStepper cotenant={cotenant} showSummary={showSummary} />
        )}
      </div>
      {showSummary && lease?.lease_pricing && (
        <>
          <SidebarAppDetails cotenant={cotenant} />
          <SideBarIncentives
            applicationWizard={applicationWizard}
            cotenantId={cotenantId}
            leasePricing={lease?.lease_pricing}
            isPreview={isPreview}
          />
          <SidebarPaymentDetails leasePricing={lease?.lease_pricing} />
        </>
      )}
    </Card>
  );
};

export default ApplicationSidebar;
